import { render, staticRenderFns } from "./VerificationModeSwitch.vue?vue&type=template&id=734a5cb4&scoped=true&"
import script from "./VerificationModeSwitch.vue?vue&type=script&lang=js&"
export * from "./VerificationModeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./VerificationModeSwitch.vue?vue&type=style&index=0&id=734a5cb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734a5cb4",
  null
  
)

export default component.exports